@file:OptIn(InternalResourceApi::class)

package devicehub.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/devicehub.composeapp.generated.resources/"

@delegate:ResourceContentHash(-116_613_114)
internal val Res.string.vrm_output_device_hiub_title: StringResource by lazy {
      StringResource("string:vrm_output_device_hiub_title", "vrm_output_device_hiub_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11848, 68),
      ))
    }

@delegate:ResourceContentHash(-434_918_778)
internal val Res.string.vrm_output_enable_label: StringResource by lazy {
      StringResource("string:vrm_output_enable_label", "vrm_output_enable_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11917, 51),
      ))
    }

@delegate:ResourceContentHash(-661_574_536)
internal val Res.string.vrm_output_endpoint_label: StringResource by lazy {
      StringResource("string:vrm_output_endpoint_label", "vrm_output_endpoint_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11969, 93),
      ))
    }

@delegate:ResourceContentHash(-756_868_324)
internal val Res.string.vrm_output_roi_switch_label: StringResource by lazy {
      StringResource("string:vrm_output_roi_switch_label", "vrm_output_roi_switch_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12063, 71),
      ))
    }

@delegate:ResourceContentHash(-1_346_131_604)
internal val Res.string.vrm_output_screen_title: StringResource by lazy {
      StringResource("string:vrm_output_screen_title", "vrm_output_screen_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12135, 43),
      ))
    }

@delegate:ResourceContentHash(-1_625_342_383)
internal val Res.string.vrm_output_site_id_label: StringResource by lazy {
      StringResource("string:vrm_output_site_id_label", "vrm_output_site_id_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12179, 44),
      ))
    }

@delegate:ResourceContentHash(-2_134_288_700)
internal val Res.string.vrm_output_time_label: StringResource by lazy {
      StringResource("string:vrm_output_time_label", "vrm_output_time_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12224, 49),
      ))
    }

@delegate:ResourceContentHash(-546_911_018)
internal val Res.string.vrm_output_type_apt: StringResource by lazy {
      StringResource("string:vrm_output_type_apt", "vrm_output_type_apt", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12274, 59),
      ))
    }

@delegate:ResourceContentHash(1_244_185_254)
internal val Res.string.vrm_output_type_label: StringResource by lazy {
      StringResource("string:vrm_output_type_label", "vrm_output_type_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12334, 45),
      ))
    }

@delegate:ResourceContentHash(838_096_846)
internal val Res.string.vrm_output_type_other: StringResource by lazy {
      StringResource("string:vrm_output_type_other", "vrm_output_type_other", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12380, 37),
      ))
    }

@delegate:ResourceContentHash(2_107_509_488)
internal val Res.string.vrm_output_type_surepark: StringResource by lazy {
      StringResource("string:vrm_output_type_surepark", "vrm_output_type_surepark", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12418, 44),
      ))
    }

@delegate:ResourceContentHash(-236_843_731)
internal val Res.string.vrm_output_type_zatpark: StringResource by lazy {
      StringResource("string:vrm_output_type_zatpark", "vrm_output_type_zatpark", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12463, 43),
      ))
    }

@delegate:ResourceContentHash(-1_137_366_382)
internal val Res.string.vrm_output_validation_settings_label: StringResource by lazy {
      StringResource("string:vrm_output_validation_settings_label", "vrm_output_validation_settings_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12507, 72),
      ))
    }

@delegate:ResourceContentHash(1_575_788_187)
internal val Res.string.vrm_output_verify_ssl_label: StringResource by lazy {
      StringResource("string:vrm_output_verify_ssl_label", "vrm_output_verify_ssl_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12580, 51),
      ))
    }

@delegate:ResourceContentHash(246_666_453)
internal val Res.string.vrm_overlayer_auto_timezone_label: StringResource by lazy {
      StringResource("string:vrm_overlayer_auto_timezone_label", "vrm_overlayer_auto_timezone_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12632, 101),
      ))
    }

@delegate:ResourceContentHash(-1_090_656_053)
internal val Res.string.vrm_overlayer_custom_label: StringResource by lazy {
      StringResource("string:vrm_overlayer_custom_label", "vrm_overlayer_custom_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12734, 46),
      ))
    }

@delegate:ResourceContentHash(1_379_310_161)
internal val Res.string.vrm_overlayer_date_and_time_label: StringResource by lazy {
      StringResource("string:vrm_overlayer_date_and_time_label", "vrm_overlayer_date_and_time_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12781, 65),
      ))
    }

@delegate:ResourceContentHash(-1_906_760_020)
internal val Res.string.vrm_overlayer_ocr_results_label: StringResource by lazy {
      StringResource("string:vrm_overlayer_ocr_results_label", "vrm_overlayer_ocr_results_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12847, 55),
      ))
    }

@delegate:ResourceContentHash(68_938_561)
internal val Res.string.vrm_overlayer_position_label: StringResource by lazy {
      StringResource("string:vrm_overlayer_position_label", "vrm_overlayer_position_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12903, 48),
      ))
    }

@delegate:ResourceContentHash(-1_625_342_383)
internal val Res.string.vrm_overlayer_site_id_label: StringResource by lazy {
      StringResource("string:vrm_overlayer_site_id_label", "vrm_overlayer_site_id_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12952, 47),
      ))
    }

@delegate:ResourceContentHash(-1_724_705_072)
internal val Res.string.vrm_overlayer_timezone_label: StringResource by lazy {
      StringResource("string:vrm_overlayer_timezone_label", "vrm_overlayer_timezone_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13000, 48),
      ))
    }

@delegate:ResourceContentHash(592_732_096)
internal val Res.string.vrm_overlayer_title: StringResource by lazy {
      StringResource("string:vrm_overlayer_title", "vrm_overlayer_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13049, 39),
      ))
    }

@delegate:ResourceContentHash(-1_566_083_389)
internal val Res.string.vrm_position_label_bottom_left: StringResource by lazy {
      StringResource("string:vrm_position_label_bottom_left", "vrm_position_label_bottom_left", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13089, 54),
      ))
    }

@delegate:ResourceContentHash(-1_991_883_530)
internal val Res.string.vrm_position_label_bottom_right: StringResource by lazy {
      StringResource("string:vrm_position_label_bottom_right", "vrm_position_label_bottom_right", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13144, 55),
      ))
    }

@delegate:ResourceContentHash(1_329_015_489)
internal val Res.string.vrm_position_label_top_left: StringResource by lazy {
      StringResource("string:vrm_position_label_top_left", "vrm_position_label_top_left", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13200, 47),
      ))
    }

@delegate:ResourceContentHash(903_215_348)
internal val Res.string.vrm_position_label_top_right: StringResource by lazy {
      StringResource("string:vrm_position_label_top_right", "vrm_position_label_top_right", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13248, 48),
      ))
    }

@delegate:ResourceContentHash(67_446_555)
internal val Res.string.webrtc_connection_mode_normal: StringResource by lazy {
      StringResource("string:webrtc_connection_mode_normal", "webrtc_connection_mode_normal", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13297, 45),
      ))
    }

@delegate:ResourceContentHash(-1_585_922_757)
internal val Res.string.webrtc_connection_mode_private_turn_server: StringResource by lazy {
      StringResource("string:webrtc_connection_mode_private_turn_server", "webrtc_connection_mode_private_turn_server", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13343, 78),
      ))
    }

@delegate:ResourceContentHash(998_133_602)
internal val Res.string.zoom_control_title: StringResource by lazy {
      StringResource("string:zoom_control_title", "zoom_control_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13422, 34),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString2Resources(map: MutableMap<String, StringResource>) {
  map.put("vrm_output_device_hiub_title", Res.string.vrm_output_device_hiub_title)
  map.put("vrm_output_enable_label", Res.string.vrm_output_enable_label)
  map.put("vrm_output_endpoint_label", Res.string.vrm_output_endpoint_label)
  map.put("vrm_output_roi_switch_label", Res.string.vrm_output_roi_switch_label)
  map.put("vrm_output_screen_title", Res.string.vrm_output_screen_title)
  map.put("vrm_output_site_id_label", Res.string.vrm_output_site_id_label)
  map.put("vrm_output_time_label", Res.string.vrm_output_time_label)
  map.put("vrm_output_type_apt", Res.string.vrm_output_type_apt)
  map.put("vrm_output_type_label", Res.string.vrm_output_type_label)
  map.put("vrm_output_type_other", Res.string.vrm_output_type_other)
  map.put("vrm_output_type_surepark", Res.string.vrm_output_type_surepark)
  map.put("vrm_output_type_zatpark", Res.string.vrm_output_type_zatpark)
  map.put("vrm_output_validation_settings_label", Res.string.vrm_output_validation_settings_label)
  map.put("vrm_output_verify_ssl_label", Res.string.vrm_output_verify_ssl_label)
  map.put("vrm_overlayer_auto_timezone_label", Res.string.vrm_overlayer_auto_timezone_label)
  map.put("vrm_overlayer_custom_label", Res.string.vrm_overlayer_custom_label)
  map.put("vrm_overlayer_date_and_time_label", Res.string.vrm_overlayer_date_and_time_label)
  map.put("vrm_overlayer_ocr_results_label", Res.string.vrm_overlayer_ocr_results_label)
  map.put("vrm_overlayer_position_label", Res.string.vrm_overlayer_position_label)
  map.put("vrm_overlayer_site_id_label", Res.string.vrm_overlayer_site_id_label)
  map.put("vrm_overlayer_timezone_label", Res.string.vrm_overlayer_timezone_label)
  map.put("vrm_overlayer_title", Res.string.vrm_overlayer_title)
  map.put("vrm_position_label_bottom_left", Res.string.vrm_position_label_bottom_left)
  map.put("vrm_position_label_bottom_right", Res.string.vrm_position_label_bottom_right)
  map.put("vrm_position_label_top_left", Res.string.vrm_position_label_top_left)
  map.put("vrm_position_label_top_right", Res.string.vrm_position_label_top_right)
  map.put("webrtc_connection_mode_normal", Res.string.webrtc_connection_mode_normal)
  map.put("webrtc_connection_mode_private_turn_server", Res.string.webrtc_connection_mode_private_turn_server)
  map.put("zoom_control_title", Res.string.zoom_control_title)
}
